export class UserCompanyInfo {
    public companyCode: string = '';
    public companyName: string = '';
    public facilityAddress: string = '';
    public companyLogo!: boolean;
    public logoLastModified!: number;
    public companyId!: number;
}
